import { isNumber } from "./Number";
import { getType, ObjectType } from "./Object";
import { isNullOrWhiteSpace, isString } from "./String";

export function toBoolean(value: unknown, defaultValue = false): boolean {
  if (value == null) {
    return defaultValue;
  }

  if (isBoolean(value)) {
    return value;
  }

  if (isString(value)) {
    return fromString(value);
  }

  if (isNumber(value)) {
    return fromNumber(value);
  }

  return defaultValue;
}

export function isTrue(value: unknown, defaultValue = false): boolean {
  return toBoolean(value, defaultValue) === true;
}

export function isFalse(value: unknown, defaultValue = false): boolean {
  return toBoolean(value, defaultValue) === false;
}

function fromString(value: string) {
  if (isNullOrWhiteSpace(value)) {
    return false;
  }

  return value.toLowerCase() === `true`;
}

function fromNumber(value: number) {
  if (value == null) {
    return false;
  }

  return value === 1;
}

export function isBoolean(value: unknown): value is boolean {
  return getType(value) === ObjectType.Boolean;
}
